import {
    rasterTileLayer,
    rasterTrafficFlowLayer, rasterTrafficIncidentTilesLayer,
    vectorTileLayer,
    vectorTrafficFlowLayer, vectorTrafficIncidentTilesLayer,
    wmsLayer
} from 'Map/endpoints';
import queryParamUpdater from 'Map/utils/queryParamUpdater';
import baseUrlTransformer from './baseUrlTransformer';
import escapeRegExp from 'Map/utils/escapeRegExp';
import vectorRasterWmsTester from './vectorRasterWmsTester';

const VECTOR_POLYGONS_URL_PATTERN = new RegExp(escapeRegExp(vectorTileLayer));
const RASTER_POLYGONS_URL_PATTERN = new RegExp(escapeRegExp(rasterTileLayer));
const WMS_MAP_URL_PATTERN = new RegExp(escapeRegExp(wmsLayer));
const VECTOR_TRAFFIC_FLOW_URL_PATTERN = new RegExp(escapeRegExp(vectorTrafficFlowLayer));
const RASTER_TRAFFIC_FLOW_URL_PATTERN = new RegExp(escapeRegExp(rasterTrafficFlowLayer));
const VECTOR_TRAFFIC_INCIDENTS_URL_PATTERN = new RegExp(escapeRegExp(vectorTrafficIncidentTilesLayer));
const RASTER_TRAFFIC_INCIDENTS_URL_PATTERN = new RegExp(escapeRegExp(rasterTrafficIncidentTilesLayer));

const LANGUAGE_PARAM_NAME = 'language';
const GEOPOLITICAL_VIEW_PARAM_NAME = 'view';
const TRAFFIC_MODEL_ID_PARAM_NAME = 't';

export function mapPolygonsUrlTransformer(key, mapSource, languageGetter, geopolViewGetter) {

    const testMethodImpl = vectorRasterWmsTester(mapSource, VECTOR_POLYGONS_URL_PATTERN, RASTER_POLYGONS_URL_PATTERN,
        WMS_MAP_URL_PATTERN);

    const transformMethodImpl = (url) => {
        url = queryParamUpdater(url, LANGUAGE_PARAM_NAME, languageGetter());
        return queryParamUpdater(url, GEOPOLITICAL_VIEW_PARAM_NAME, geopolViewGetter());
    };

    return baseUrlTransformer(key, testMethodImpl, transformMethodImpl);
}

export function trafficFlowUrlTransformer(key, trafficFlowSource) {
    const testMethodImpl = vectorRasterWmsTester(trafficFlowSource, VECTOR_TRAFFIC_FLOW_URL_PATTERN,
        RASTER_TRAFFIC_FLOW_URL_PATTERN);

    return baseUrlTransformer(key, testMethodImpl);
}

export function trafficIncidentsUrlTransformer(key, trafficFlowSource, trafficModelIdGetter) {
    const testMethodImpl = vectorRasterWmsTester(trafficFlowSource, VECTOR_TRAFFIC_INCIDENTS_URL_PATTERN,
        RASTER_TRAFFIC_INCIDENTS_URL_PATTERN);

    const transformMethodImpl = (url) => {
        return queryParamUpdater(url, TRAFFIC_MODEL_ID_PARAM_NAME, trafficModelIdGetter());
    };

    return baseUrlTransformer(key, testMethodImpl, transformMethodImpl);
}



// WEBPACK FOOTER //
// ./map/tier/urlTransformers/urlTransformers.js